import { render, staticRenderFns } from "./LastSection.vue?vue&type=template&id=e320294c&scoped=true&"
var script = {}
import style0 from "./LastSection.vue?vue&type=style&index=0&id=e320294c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e320294c",
  null
  
)

export default component.exports